var exports = {
  "wI": "WhatsNewModal.module__whatsNewRoot___RVMwYm",
  "UT": "WhatsNewModal.module__contentShell___RVMwYm",
  "yp": "WhatsNewModal.module__contentBody___RVMwYm",
  "hZ": "WhatsNewModal.module__dateLine___RVMwYm",
  "eM": "WhatsNewModal.module__markdownBody___RVMwYm",
  "qr": "WhatsNewModal.module__footer___RVMwYm",
  "r": "WhatsNewModal.module__dismissButton___RVMwYm",
  "T7": "WhatsNewModal.module__scrollHint___RVMwYm",
  "LL": "WhatsNewModal.module__scrollHintVisible___RVMwYm",
  "HF": "WhatsNewModal.module__scrollHintCircle___RVMwYm",
  "ki": "WhatsNewModal.module__scrollHintPulse___RVMwYm",
};

module.exports = exports;
